var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHome3 = function SvgHome3(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#home-3_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#282D3C",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M15.5 22v-7c0-.932 0-1.398-.152-1.765a2 2 0 0 0-1.083-1.082C13.898 12 13.432 12 12.5 12v0c-.932 0-1.398 0-1.765.152a2 2 0 0 0-1.083 1.083C9.5 13.602 9.5 14.068 9.5 15v7M7.502 3.998l-2 1.6C4.4 6.48 3.85 6.921 3.452 7.468a5 5 0 0 0-.772 1.607c-.18.652-.18 1.358-.18 2.77V14c0 2.8 0 4.2.545 5.27a5 5 0 0 0 2.185 2.185C6.3 22 7.7 22 10.5 22h4c2.8 0 4.2 0 5.27-.545a5 5 0 0 0 2.185-2.185c.545-1.07.545-2.47.545-5.27v-2.155c0-1.412 0-2.118-.18-2.77a5 5 0 0 0-.772-1.606c-.397-.548-.948-.989-2.05-1.87l-2-1.6c-1.784-1.428-2.676-2.141-3.665-2.415a5 5 0 0 0-2.666 0c-.99.274-1.881.987-3.665 2.414"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "home-3_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.5 0h24v24H.5z"
  })))));
};
export default SvgHome3;